<template>
  <div class="chooseItem">
    <div class="title-wrap">
      <p class="fs-36 color-black bold">
        {{ trans['extra_options'] }}
      </p>
      <button
        v-if="isCompleted"
        class="btn btn-link"
        @click="reset"
      >
        {{ trans.change }}
      </button>
    </div>

    <collapse-transition :duration="800">
      <div v-if="isActive && !isCompleted">
        <div
          v-for="item in other"
          :key="item.id"
          class="groupOptions"
        >
          <div class="option-title">
            <p class="fs-24 medium">{{ item.title }}</p>
            <p class="fs-24">{{ $crConverter(item.price / 100, 'EUR', '%s +%v') }}</p>
          </div>
          <ul class="checkbox-list option-wrap">
            <li class="checkboxEl">
              <div class="stripe"/>
              <p class="noneText">{{ trans.none }}</p>
            </li>
            <li class="checkboxEl">
              <p class="titleOption">{{ item.title }}</p>
              <p class="textOption">{{ item['short_description'] }}</p>
            </li>
          </ul>
        </div>

        <div v-if="pedals.length > 0" class="groupOptions">
          <div class="option-title">
            <p class="fs-24 medium">{{ trans.pedals }}</p>
          </div>
          <ul class="checkbox-list pedal-wrap">
            <li
              v-for="pedal in pedals"
              :key="pedal.id"
              :class="extraOptionClass(pedal)"
              class="checkboxEl"
              @click="pushToExtra(pedal)"
            >
              <div class="stripe"/>
              <img
                :alt="pedal.title"
                :src="pedal.image"
                class="imgOption"
              />
              <p class="nameOption">{{ pedal.title }}</p>
              <p class="priceOption">
                {{ $crConverter(pedal.price / 100, 'EUR', '%s +%v') }}
              </p>
            </li>
            <li
              :class="removePedalsBtnClass"
              class="checkboxEl"
              @click="removePedalsFromExtra()">
              <p class="noneText">{{ trans['no_thx'] }}</p>
            </li>
          </ul>
        </div>

        <button
          class="btn btn-green"
          type="button"
          @click="confirmSelected"
        >
          {{ trans['confirm_extra_options'] }}
        </button>
      </div>
    </collapse-transition>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {CollapseTransition} from "@ivanv/vue-collapse-transition";

export default {
  name: "ExtraOptions",
  props: ['step', 'trans'],
  data() {
    return {
      confirmed: false
    }
  },
  components: {
    'collapse-transition': CollapseTransition
  },
  computed: {
    ...mapGetters({
      extra: 'build/extraList',
      addedExtra: 'build/extra',
      steps: 'build/stepList',
    }),
    pedals() {
      return this.extra.filter(item => {
        return item['sub_category'] === 'Pedals'
      })
    },
    other() {
      return this.extra.filter(item => {
        return item['sub_category'] !== 'Pedals'
      })
    },
    hasExtraPedals() {
      return this.addedExtra.find(item => {
        return item['sub_category'] === 'Pedals'
      }) !== undefined
    },
    removePedalsBtnClass() {
      return {
        active: !this.hasExtraPedals
      }
    },
    isCompleted() {
      return this.confirmed
    },
    isActive() {
      return this.steps[this.step].active
    },
  },
  methods: {
    reset() {
      this.confirmed = false
    },
    pushToExtra(extra) {
      if (!this.added(extra)) {
        this.$store.commit('build/pushToExtra', extra)
      }
    },
    added(extra) {
      return this.addedExtra.find(item => {
        return item.id === extra.id
      }) !== undefined
    },
    extraOptionClass(extra) {
      return {
        active: this.added(extra)
      }
    },
    removePedalsFromExtra() {
      if (this.hasExtraPedals) {
        this.$store.commit('build/removePedalsFromExtra')
      }
    },
    confirmSelected() {
      this.confirmed = true
      this.$emit('onConfirmed')
    }
  }
}
</script>
